export const movies = [
  {
    id: "mv-01",
    title: "星际迷航：黎明",
    originalTitle: "Star Voyage: Dawn",
    year: 2024,
    region: "美国",
    type: "电影",
    genres: ["科幻", "冒险"],
    director: "艾略特·格兰特",
    actors: ["瑞恩·科森", "艾米·瓦伦", "卢卡斯·贝尔"],
    rating: 8.9,
    views: 1286.5,
    duration: "148分钟",
    overview:
      "一支深空探索舰队在跃迁途中闯入未知星域，遭遇一场足以改写人类命运的宇宙风暴。船长安森必须在燃油、时间与船员生命之间做出抉择，而一颗神秘的环行星正缓缓揭开它隐藏数千年的秘密。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20movie%20poster%20artwork%20featuring%20a%20lone%20astronaut%20silhouette%20before%20a%20glowing%20nebula%20and%20a%20distant%20ringed%20planet%2C%20deep%20navy%20blue%20and%20warm%20orange%20cinematic%20lighting%2C%20dramatic%20volumetric%20rays%2C%20high%20detail%20film%20grain%2C%20minimal%20graphic%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=movie-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20science%20fiction%20film%20still%20of%20a%20vast%20starfield%20with%20a%20colossal%20ringed%20planet%20and%20a%20sleek%20spacecraft%20gliding%20past%2C%20deep%20navy%20space%20and%20amber%20engine%20glow%2C%20atmospheric%20haze%2C%20dramatic%20lighting%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-01&orientation=landscape",
    tags: ["宇宙", "太空歌剧", "视效大片", "高能"],
  },
  {
    id: "mv-02",
    title: "长安十二辰",
    originalTitle: "Twelve Hours in Chang'an",
    year: 2023,
    region: "大陆",
    type: "电影",
    genres: ["历史", "悬疑"],
    director: "陆闻舟",
    actors: ["沈砚", "苏清晏", "裴无咎"],
    rating: 8.6,
    views: 1043.2,
    duration: "132分钟",
    overview:
      "帝国都城在十二个时辰内将迎来一场精心策划的浩劫。一名被贬的低阶官员与被通缉的游侠被迫联手，在灯火与暗巷之间追查真相。时间一分一秒流逝，真相却比阴谋更加令人不安。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20historical%20drama%20movie%20poster%20artwork%20of%20an%20ancient%20eastern%20walled%20city%20at%20dusk%20with%20lantern-lit%20towers%20and%20a%20cloaked%20figure%20on%20a%20rooftop%2C%20warm%20amber%20lantern%20glow%20against%20cool%20indigo%20night%2C%20moody%20atmospheric%20lighting%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=movie-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20historical%20film%20still%20of%20an%20ancient%20eastern%20imperial%20city%20skyline%20at%20dusk%20with%20glowing%20lanterns%2C%20tiled%20rooftops%20and%20drifting%20mist%2C%20indigo%20night%20sky%20with%20warm%20amber%20highlights%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-02&orientation=landscape",
    tags: ["古装", "烧脑", "群像", "高口碑"],
  },
  {
    id: "mv-03",
    title: "无声告白",
    originalTitle: "The Silent Confession",
    year: 2024,
    region: "大陆",
    type: "电影",
    genres: ["剧情", "悬疑"],
    director: "周砚青",
    actors: ["林澈", "程知微"],
    rating: 8.2,
    views: 712.8,
    duration: "118分钟",
    overview:
      "一场大雨夜，独居的女孩向警方报出一桩无人相信的凶案。没有尸体，没有血迹，只有一段被她反复删除又恢复的录音。当所有人都在怀疑她的精神时，调查记者决定相信她一次。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20mystery%20thriller%20movie%20poster%20artwork%20of%20a%20solitary%20figure%20standing%20in%20heavy%20rain%20on%20a%20neon-lit%20empty%20street%2C%20cold%20steel%20blue%20tones%20with%20a%20single%20warm%20streetlamp%2C%20wet%20reflections%2C%20moody%20dramatic%20lighting%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=movie-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20mystery%20thriller%20film%20still%20of%20a%20rain-soaked%20empty%20city%20street%20at%20night%20with%20glowing%20streetlamps%20and%20wet%20reflective%20asphalt%2C%20cold%20steel%20blue%20palette%20with%20warm%20highlights%2C%20heavy%20atmospheric%20fog%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-03&orientation=landscape",
    tags: ["悬疑", "心理", "反转", "都市"],
  },
  {
    id: "mv-04",
    title: "深海奇缘",
    originalTitle: "The Deep Blue",
    year: 2022,
    region: "美国",
    type: "电影",
    genres: ["冒险", "奇幻"],
    director: "玛雅·诺兰",
    actors: ["伊森·瑞德", "克拉拉·方"],
    rating: 8.4,
    views: 968.1,
    duration: "126分钟",
    overview:
      "为了寻找失踪的科考船，海洋生物学家潜入从未被人类踏足的海沟。在发光的珊瑚与巨鲸的哀鸣之间，她发现了一个远比传说更温柔，也更危险的深海世界。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20underwater%20fantasy%20adventure%20movie%20poster%20artwork%20of%20a%20diver%20descending%20into%20a%20luminous%20deep%20ocean%20trench%20with%20glowing%20coral%20and%20giant%20whale%20silhouettes%2C%20teal%20and%20deep%20aqua%20tones%20with%20warm%20bioluminescent%20accents%2C%20dramatic%20god%20rays%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=movie-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20underwater%20fantasy%20film%20still%20of%20a%20glowing%20deep%20ocean%20trench%20with%20bioluminescent%20coral%20and%20a%20giant%20whale%20silhouette%20drifting%20through%20god%20rays%2C%20deep%20teal%20aqua%20palette%20with%20warm%20accents%2C%20atmospheric%20particles%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-04&orientation=landscape",
    tags: ["海洋", "治愈", "视效", "合家欢"],
  },
  {
    id: "mv-05",
    title: "时间裂缝",
    originalTitle: "Fractures of Time",
    year: 2025,
    region: "欧洲",
    type: "电影",
    genres: ["科幻", "悬疑"],
    director: "安娜·贝克尔",
    actors: ["卢卡·莫里", "索菲·雷恩"],
    rating: 8.7,
    views: 521.6,
    duration: "134分钟",
    overview:
      "城市上空裂开一道会缓慢移动的发光缝隙，所有穿过它的人都会失去一段记忆。一名钟表匠发现，只有他记得那些被抹除的时刻，而缝隙正朝着他家的方向靠近。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20suspense%20movie%20poster%20artwork%20of%20a%20fractured%20clock%20face%20dissolving%20into%20geometric%20light%20shards%20above%20a%20lone%20figure%2C%20cold%20cyan%20deep%20blue%20tones%20with%20warm%20amber%20sparks%2C%20dramatic%20lighting%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=movie-poster-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20science%20fiction%20film%20still%20of%20a%20massive%20glowing%20time%20portal%20fracturing%20above%20a%20misty%20modern%20city%20skyline%2C%20deep%20blue%20palette%20with%20warm%20amber%20energy%2C%20atmospheric%20haze%2C%20dramatic%20lighting%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-05&orientation=landscape",
    tags: ["时间", "烧脑", "欧洲电影", "新片"],
  },
  {
    id: "mv-06",
    title: "风起云涌",
    originalTitle: "Rising Storm",
    year: 2022,
    region: "大陆",
    type: "电影",
    genres: ["动作", "战争"],
    director: "雷建国",
    actors: ["秦川", "顾长风", "白鹭"],
    rating: 7.9,
    views: 856.3,
    duration: "142分钟",
    overview:
      "黎明前的最后一场战役里，一支被遗忘的连队必须守住阵地三小时，为大部队争取时间。硝烟、泥泞与彼此的名字，是他们唯一拥有的东西。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20action%20war%20movie%20poster%20artwork%20of%20soldiers%20advancing%20through%20dust%20and%20smoke%20toward%20a%20distant%20burning%20horizon%20under%20a%20dramatic%20sky%2C%20muted%20olive%20and%20deep%20blue%20tones%20with%20intense%20orange%20fire%20glow%2C%20gritty%20atmospheric%20lighting%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=movie-poster-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20action%20war%20film%20still%20of%20a%20vast%20battlefield%20at%20dawn%20with%20drifting%20smoke%2C%20distant%20explosions%20and%20silhouetted%20figures%20advancing%2C%20muted%20olive%20and%20deep%20blue%20palette%20with%20intense%20orange%20fire%20glow%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-06&orientation=landscape",
    tags: ["主旋律", "战争", "热血", "硬核"],
  },
  {
    id: "mv-07",
    title: "城市之光",
    originalTitle: "City Lights",
    year: 2023,
    region: "港台",
    type: "电影",
    genres: ["爱情", "剧情"],
    director: "陈嘉宜",
    actors: ["梁以宁", "方可欣"],
    rating: 7.6,
    views: 634.9,
    duration: "110分钟",
    overview:
      "两个在深夜便利店相遇的陌生人，约定只在城市睡着时见面。一千个夜晚之后，他们都必须面对同一个问题：当白天来临，这段关系会留下什么。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20romantic%20drama%20movie%20poster%20artwork%20of%20two%20figures%20standing%20apart%20on%20a%20glowing%20city%20bridge%20at%20night%20under%20warm%20streetlights%2C%20soft%20warm%20amber%20and%20deep%20blue%20tones%2C%20dreamy%20bokeh%20lights%2C%20tender%20atmospheric%20lighting%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=movie-poster-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20romantic%20drama%20film%20still%20of%20a%20glowing%20modern%20city%20skyline%20at%20night%20viewed%20from%20a%20bridge%20with%20warm%20streetlights%20and%20soft%20bokeh%2C%20deep%20blue%20palette%20with%20warm%20amber%20highlights%2C%20dreamy%20atmospheric%20haze%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-07&orientation=landscape",
    tags: ["文艺", "都市", "治愈", "慢节奏"],
  },
  {
    id: "mv-08",
    title: "荒野猎人日记",
    originalTitle: "Wilderness Diaries",
    year: 2021,
    region: "美国",
    type: "电影",
    genres: ["冒险", "剧情"],
    director: "杰克·哈里斯",
    actors: ["诺亚·布莱克", "艾拉·斯通"],
    rating: 8.1,
    views: 588.4,
    duration: "130分钟",
    overview:
      "一名厌倦城市的程序员独自踏上穿越雪山的徒步路线，却在暴风雪中迷失方向。求生本能与内心独白交织，让他重新理解了「活着」这件事。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20wilderness%20adventure%20movie%20poster%20artwork%20of%20a%20lone%20hunter%20crossing%20a%20vast%20snowy%20mountain%20valley%20beneath%20dramatic%20storm%20clouds%2C%20muted%20cool%20teal%20and%20warm%20earth%20tones%2C%20epic%20scale%20atmospheric%20lighting%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=movie-poster-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20wilderness%20survival%20film%20still%20of%20a%20vast%20snowy%20mountain%20valley%20with%20a%20lone%20figure%20crossing%20beneath%20towering%20storm%20clouds%2C%20muted%20cool%20teal%20and%20warm%20earth%20palette%2C%20epic%20atmospheric%20haze%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=movie-backdrop-08&orientation=landscape",
    tags: ["求生", "自然", "励志", "摄影"],
  },
  {
    id: "tv-01",
    title: "长安风云录",
    originalTitle: "Chronicles of Chang'an",
    year: 2024,
    region: "大陆",
    type: "电视剧",
    genres: ["古装", "历史"],
    director: "顾长风",
    actors: ["谢云辞", "温挽", "燕无归", "柳千树"],
    rating: 8.8,
    views: 2189.7,
    duration: "全集45集",
    overview:
      "乱世之中，一个出身寒微的少年一步步走进权力的中心。他既要守护心中所爱，也要在朝堂的风云里保全自己。一部关于权谋、忠诚与成长的史诗群像剧。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20ancient%20costume%20drama%20series%20poster%20artwork%20of%20a%20noble%20figure%20in%20flowing%20eastern%20robes%20standing%20before%20a%20grand%20palace%20gate%20with%20falling%20golden%20leaves%2C%20rich%20crimson%20and%20deep%20gold%20tones%20with%20indigo%20shadows%2C%20elegant%20atmospheric%20lighting%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=tv-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20costume%20drama%20series%20still%20of%20a%20grand%20ancient%20eastern%20palace%20courtyard%20with%20golden%20autumn%20leaves%20drifting%20and%20silhouetted%20attendants%2C%20rich%20crimson%20gold%20palette%20with%20indigo%20shadows%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=tv-backdrop-01&orientation=landscape",
    tags: ["权谋", "群像", "古装", "热播"],
  },
  {
    id: "tv-02",
    title: "都市男女",
    originalTitle: "City Hearts",
    year: 2023,
    region: "大陆",
    type: "电视剧",
    genres: ["都市", "爱情"],
    director: "林蔚然",
    actors: ["方予安", "陆一川", "苏念"],
    rating: 7.8,
    views: 1563.2,
    duration: "全集36集",
    overview:
      "四个在写字楼里打拼的年轻人，用一场场加班、一次次错过和一句句说不出口的喜欢，拼凑出属于这个时代的都市爱情图鉴。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20modern%20city%20romance%20series%20poster%20artwork%20of%20a%20stylish%20young%20couple%20walking%20through%20a%20bright%20contemporary%20downtown%20at%20golden%20hour%2C%20warm%20coral%20and%20deep%20blue%20tones%2C%20clean%20cinematic%20lighting%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=tv-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20modern%20city%20romance%20series%20still%20of%20a%20bright%20contemporary%20downtown%20street%20at%20golden%20hour%20with%20stylish%20pedestrians%20and%20glass%20towers%2C%20warm%20coral%20and%20deep%20blue%20palette%2C%20clean%20atmospheric%20light%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=tv-backdrop-02&orientation=landscape",
    tags: ["都市", "甜宠", "职场", "轻松"],
  },
  {
    id: "tv-03",
    title: "迷雾追凶",
    originalTitle: "Through the Mist",
    year: 2024,
    region: "美国",
    type: "电视剧",
    genres: ["悬疑", "犯罪"],
    director: "丹尼尔·波特",
    actors: ["托马斯·凯恩", "莉娜·福德"],
    rating: 9.0,
    views: 1824.6,
    duration: "全集12集",
    overview:
      "一座常年被浓雾笼罩的港口小城，每隔七年就会发生一起无法解释的失踪案。新调任的警探发现，所有线索都指向三十年前那桩被匆匆结案的旧案。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20series%20poster%20artwork%20of%20a%20detective%20in%20a%20coat%20examining%20clues%20under%20a%20dim%20warehouse%20lamp%20amid%20swirling%20fog%2C%20cold%20desaturated%20steel%20blue%20tones%20with%20a%20single%20warm%20lamp%2C%20tense%20atmospheric%20lighting%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=tv-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20crime%20thriller%20series%20still%20of%20a%20dim%20industrial%20warehouse%20interior%20filled%20with%20swirling%20fog%20and%20a%20single%20warm%20hanging%20lamp%2C%20cold%20steel%20blue%20palette%2C%20tense%20atmospheric%20haze%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=tv-backdrop-03&orientation=landscape",
    tags: ["悬疑", "犯罪", "高分", "一口气看"],
  },
  {
    id: "tv-04",
    title: "医者仁心",
    originalTitle: "Healer's Oath",
    year: 2023,
    region: "大陆",
    type: "电视剧",
    genres: ["医疗", "都市"],
    director: "许静之",
    actors: ["周牧白", "林之夏", "陈砚舟"],
    rating: 8.5,
    views: 1398.9,
    duration: "全集40集",
    overview:
      "急诊室的灯从不熄灭。一群年轻医生在生死之间学习成长，也在一次次选择里回答同一个问题：什么是真正的医者仁心。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20series%20poster%20artwork%20of%20a%20dedicated%20doctor%20in%20scrubs%20standing%20in%20a%20softly%20lit%20hospital%20corridor%20at%20dawn%2C%20clean%20teal%20and%20warm%20white%20tones%20with%20deep%20blue%20shadows%2C%20hopeful%20atmospheric%20lighting%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=tv-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20medical%20drama%20series%20still%20of%20a%20softly%20lit%20modern%20hospital%20corridor%20at%20dawn%20with%20silhouetted%20medical%20staff%20and%20clean%20reflective%20floors%2C%20clean%20teal%20and%20warm%20white%20palette%20with%20deep%20blue%20shadows%2C%20atmospheric%20light%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=tv-backdrop-04&orientation=landscape",
    tags: ["医疗", "行业剧", "催泪", "正能量"],
  },
  {
    id: "tv-05",
    title: "海岸线",
    originalTitle: "The Coastline",
    year: 2021,
    region: "日韩",
    type: "电视剧",
    genres: ["剧情", "治愈"],
    director: "森川海里",
    actors: ["结城遥", "宫泽凛"],
    rating: 8.3,
    views: 876.5,
    duration: "全集16集",
    overview:
      "一间开在海边的小咖啡馆，接待着每一位带着心事而来的客人。店主话不多，却总能用一杯咖啡，陪人走完最难走的那段路。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20healing%20seaside%20drama%20series%20poster%20artwork%20of%20a%20small%20coastal%20town%20by%20a%20calm%20turquoise%20sea%20at%20sunrise%20with%20a%20lone%20walker%20on%20the%20shore%2C%20soft%20aqua%20and%20warm%20peach%20tones%2C%20gentle%20atmospheric%20light%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=tv-poster-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20healing%20drama%20series%20still%20of%20a%20serene%20coastal%20town%20shoreline%20at%20sunrise%20with%20gentle%20waves%20and%20warm%20peach%20sky%2C%20soft%20aqua%20palette%20with%20warm%20highlights%2C%20calm%20atmospheric%20haze%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=tv-backdrop-05&orientation=landscape",
    tags: ["治愈", "慢生活", "日剧", "美食"],
  },
  {
    id: "tv-06",
    title: "家族荣耀",
    originalTitle: "House of Honor",
    year: 2022,
    region: "港台",
    type: "电视剧",
    genres: ["家庭", "商战"],
    director: "何嘉树",
    actors: ["郑维安", "梁思雅", "霍敬亭"],
    rating: 8.0,
    views: 1124.3,
    duration: "全集30集",
    overview:
      "当家族企业的掌舵人突然离世，一份出乎意料的遗嘱让所有人都成了嫌疑人。金钱、亲情与真相，在这座老宅里被反复称量。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20family%20business%20drama%20series%20poster%20artwork%20of%20a%20powerful%20family%20gathered%20around%20a%20grand%20dining%20table%20in%20an%20elegant%20mansion%20with%20warm%20chandelier%20light%2C%20deep%20burgundy%20and%20gold%20tones%2C%20dramatic%20atmospheric%20lighting%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=tv-poster-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20family%20drama%20series%20still%20of%20an%20elegant%20mansion%20interior%20with%20a%20grand%20dining%20hall%20and%20warm%20chandelier%20glow%2C%20deep%20burgundy%20and%20gold%20palette%2C%20dramatic%20atmospheric%20light%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=tv-backdrop-06&orientation=landscape",
    tags: ["商战", "家族", "港剧", "反转"],
  },
  {
    id: "tv-07",
    title: "青春纪事",
    originalTitle: "Youth Notes",
    year: 2025,
    region: "大陆",
    type: "电视剧",
    genres: ["青春", "校园"],
    director: "夏语冰",
    actors: ["沈知夏", "江屿", "温以宁"],
    rating: 7.7,
    views: 654.2,
    duration: "全集24集",
    overview:
      "高三最后一个春天，一群少年在课本、操场与天台之间，认真地和青春告别。那些没说出口的话，最终都写进了毕业册的最后一页。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20youth%20campus%20drama%20series%20poster%20artwork%20of%20students%20walking%20along%20a%20tree-lined%20school%20path%20in%20bright%20spring%20sunlight%20with%20drifting%20petals%2C%20fresh%20green%20and%20warm%20sky%20blue%20tones%2C%20bright%20airy%20atmospheric%20lighting%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=tv-poster-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20youth%20campus%20series%20still%20of%20a%20sunlit%20tree-lined%20school%20walkway%20with%20drifting%20petals%20and%20silhouetted%20students%20in%20spring%2C%20fresh%20green%20palette%20with%20warm%20sky%20blue%2C%20bright%20airy%20atmospheric%20light%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=tv-backdrop-07&orientation=landscape",
    tags: ["校园", "青春", "新剧", "治愈"],
  },
  {
    id: "va-01",
    title: "星光大道之夜",
    originalTitle: "Avenue of Stars",
    year: 2024,
    region: "大陆",
    type: "综艺",
    genres: ["音乐", "竞技"],
    director: "总导演 · 韩磊",
    actors: ["导师团", "素人歌手"],
    rating: 8.2,
    views: 1420.8,
    duration: "每周五更新",
    overview:
      "一档面向全民的音乐梦想舞台。来自各行各业的素人歌手在这里追逐聚光灯，用一首歌的时间，把平凡的生活唱成星光。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20music%20competition%20variety%20show%20poster%20artwork%20of%20a%20dazzling%20concert%20stage%20with%20dramatic%20spotlights%20and%20a%20silhouetted%20performer%20before%20a%20huge%20crowd%2C%20vibrant%20warm%20orange%20and%20deep%20blue%20stage%20lights%2C%20energetic%20atmospheric%20glow%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=va-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20music%20competition%20variety%20stage%20still%20with%20dramatic%20spotlight%20beams%20crossing%20smoke%20above%20a%20silhouetted%20performer%20and%20cheering%20crowd%2C%20warm%20orange%20and%20deep%20blue%20stage%20palette%2C%20energetic%20atmospheric%20glow%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=va-backdrop-01&orientation=landscape",
    tags: ["音乐", "选秀", "励志", "热播"],
  },
  {
    id: "va-02",
    title: "荒野求生",
    originalTitle: "Into the Wild",
    year: 2023,
    region: "美国",
    type: "综艺",
    genres: ["真人秀", "冒险"],
    director: "总导演 · 迈克·里德",
    actors: ["冒险嘉宾团"],
    rating: 8.6,
    views: 986.4,
    duration: "每周日更新",
    overview:
      "八位嘉宾被投放到无人荒野，仅携带一件工具。他们要在有限资源中搭建庇护所、寻找水源，并完成一场关于勇气与合作的极限挑战。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20wilderness%20survival%20reality%20show%20poster%20artwork%20of%20an%20adventurer%20crossing%20a%20dramatic%20rocky%20canyon%20under%20a%20vast%20sky%20with%20campfire%20smoke%2C%20rugged%20earth%20tones%20with%20deep%20blue%20sky%2C%20epic%20atmospheric%20lighting%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=va-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20wilderness%20survival%20reality%20show%20still%20of%20a%20rugged%20rocky%20canyon%20at%20golden%20hour%20with%20campfire%20smoke%20and%20an%20adventurer%20silhouette%2C%20warm%20earth%20tones%20with%20deep%20blue%20sky%2C%20epic%20atmospheric%20haze%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=va-backdrop-02&orientation=landscape",
    tags: ["真人秀", "探险", "高能", "户外"],
  },
  {
    id: "va-03",
    title: "厨神争霸赛",
    originalTitle: "Chef Masters",
    year: 2024,
    region: "大陆",
    type: "综艺",
    genres: ["美食", "竞技"],
    director: "总导演 · 于晓峰",
    actors: ["名厨评审团"],
    rating: 7.9,
    views: 1120.7,
    duration: "每周六更新",
    overview:
      "来自全国各地的厨师同台竞技，用一道菜的时间决出胜负。刀工、火候与创意之外，真正比拼的是对食材的尊重与理解。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20cooking%20competition%20show%20poster%20artwork%20of%20a%20dramatic%20kitchen%20scene%20with%20flames%20leaping%20from%20a%20pan%20and%20flying%20ingredients%2C%20vibrant%20warm%20orange%20and%20deep%20blue%20tones%2C%20dynamic%20energetic%20lighting%2C%20high%20detail%20film%20grain%2C%20minimal%20composition%20with%20no%20text%20or%20letters&width=600&height=900&seq=va-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20cooking%20competition%20show%20still%20of%20a%20dramatic%20professional%20kitchen%20with%20flames%20leaping%20and%20flying%20ingredients%20under%20warm%20spotlights%2C%20vibrant%20warm%20orange%20palette%20with%20deep%20blue%20shadows%2C%20dynamic%20atmospheric%20light%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=va-backdrop-03&orientation=landscape",
    tags: ["美食", "竞技", "下饭", "创意"],
  },
  {
    id: "an-01",
    title: "龙之谷传说",
    originalTitle: "Legend of Dragon Valley",
    year: 2024,
    region: "日韩",
    type: "动漫",
    genres: ["奇幻", "热血"],
    director: "监督 · 高桥悠真",
    actors: ["声优 · 花泽凛", "声优 · 佐仓空"],
    rating: 8.9,
    views: 1320.5,
    duration: "全24话",
    overview:
      "在悬浮于云端的龙之谷，一名被村人视为灾星的少年，意外唤醒了沉睡千年的古龙。为了证明自己，也为了守护家园，他踏上了一场关于勇气与羁绊的旅程。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20anime%20poster%20artwork%20of%20a%20young%20hero%20standing%20before%20a%20colossal%20ancient%20dragon%20amidst%20floating%20mountains%20and%20glowing%20runes%2C%20vivid%20teal%20and%20warm%20gold%20tones%2C%20epic%20dramatic%20lighting%2C%20high%20detail%20clean%20anime%20illustration%20style%2C%20no%20text%20or%20letters&width=600&height=900&seq=an-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20fantasy%20anime%20still%20of%20a%20colossal%20ancient%20dragon%20soaring%20over%20floating%20mountains%20with%20glowing%20runes%2C%20vivid%20teal%20and%20warm%20gold%20palette%2C%20epic%20dramatic%20light%2C%20detailed%20anime%20illustration%2C%20no%20text&width=1600&height=900&seq=an-backdrop-01&orientation=landscape",
    tags: ["奇幻", "热血", "冒险", "高燃"],
  },
  {
    id: "an-02",
    title: "宇宙少年",
    originalTitle: "Cosmo Boy",
    year: 2023,
    region: "日韩",
    type: "动漫",
    genres: ["科幻", "机战"],
    director: "监督 · 石田海斗",
    actors: ["声优 · 木村翔", "声优 · 早乙女遥"],
    rating: 8.4,
    views: 1098.3,
    duration: "全26话",
    overview:
      "少年在一次意外中与失落的巨型机甲建立了精神链接。当城市面临来自天空的威胁，他必须驾驭这台孤独的机器，成为人类最后的防线。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20mecha%20science%20fiction%20anime%20poster%20artwork%20of%20a%20young%20pilot%20beside%20a%20towering%20robot%20amid%20a%20neon-lit%20futuristic%20city%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dynamic%20dramatic%20lighting%2C%20high%20detail%20clean%20anime%20illustration%20style%2C%20no%20text%20or%20letters&width=600&height=900&seq=an-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20mecha%20anime%20still%20of%20a%20towering%20robot%20standing%20in%20a%20neon-lit%20futuristic%20city%20at%20dusk%2C%20deep%20blue%20palette%20with%20warm%20orange%20glow%2C%20dynamic%20dramatic%20light%2C%20detailed%20anime%20illustration%2C%20no%20text&width=1600&height=900&seq=an-backdrop-02&orientation=landscape",
    tags: ["机甲", "科幻", "热血", "少年"],
  },
  {
    id: "an-03",
    title: "樱花物语",
    originalTitle: "Sakura Story",
    year: 2022,
    region: "日韩",
    type: "动漫",
    genres: ["治愈", "校园"],
    director: "监督 · 小林夏织",
    actors: ["声优 · 佐藤光", "声优 · 高桥菜月"],
    rating: 8.1,
    views: 764.8,
    duration: "全12话",
    overview:
      "转学生与新同桌在樱花树下相遇，一段安静而温柔的青春故事就此展开。没有惊天动地，只有那些被小心收藏的、闪闪发光的日常。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20healing%20school%20anime%20poster%20artwork%20of%20two%20students%20under%20a%20blooming%20cherry%20blossom%20tree%20in%20soft%20spring%20light%20with%20drifting%20petals%2C%20gentle%20pink%20and%20sky%20blue%20tones%2C%20warm%20gentle%20lighting%2C%20high%20detail%20clean%20anime%20illustration%20style%2C%20no%20text%20or%20letters&width=600&height=900&seq=an-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20healing%20anime%20still%20of%20a%20quiet%20school%20courtyard%20under%20blooming%20cherry%20blossom%20trees%20with%20drifting%20petals%2C%20gentle%20pink%20and%20sky%20blue%20palette%2C%20warm%20gentle%20light%2C%20detailed%20anime%20illustration%2C%20no%20text&width=1600&height=900&seq=an-backdrop-03&orientation=landscape",
    tags: ["治愈", "校园", "清新", "日常"],
  },
  {
    id: "an-04",
    title: "机甲战士",
    originalTitle: "Mecha Warriors",
    year: 2025,
    region: "大陆",
    type: "动漫",
    genres: ["机战", "热血"],
    director: "导演 · 郭峰",
    actors: ["配音 · 陈昊", "配音 · 李婧"],
    rating: 8.0,
    views: 452.9,
    duration: "全20话",
    overview:
      "战火重燃的年代，一支由少年组成的机甲小队被派往最前线。他们驾驶的不只是钢铁巨兽，更是彼此交付生命的信任。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20mecha%20action%20anime%20poster%20artwork%20of%20an%20armored%20warrior%20leaping%20through%20a%20battlefield%20of%20sparks%20and%20debris%20under%20a%20stormy%20sky%2C%20intense%20crimson%20and%20deep%20blue%20tones%2C%20explosive%20dramatic%20lighting%2C%20high%20detail%20clean%20anime%20illustration%20style%2C%20no%20text%20or%20letters&width=600&height=900&seq=an-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20mecha%20action%20anime%20still%20of%20armored%20warriors%20battling%20amid%20sparks%20and%20debris%20on%20a%20stormy%20battlefield%2C%20intense%20crimson%20and%20deep%20blue%20palette%2C%20explosive%20dramatic%20light%2C%20detailed%20anime%20illustration%2C%20no%20text&width=1600&height=900&seq=an-backdrop-04&orientation=landscape",
    tags: ["机甲", "热血", "国漫", "新番"],
  },
];

export const categories = [
  {
    key: "电影",
    label: "电影",
    icon: "ri-film-line",
    desc: "院线大片、经典佳作与独立影片，一次看个过瘾。",
  },
  {
    key: "电视剧",
    label: "电视剧",
    icon: "ri-live-line",
    desc: "都市情感、古装权谋、悬疑犯罪，热门剧集持续更新。",
  },
  {
    key: "综艺",
    label: "综艺",
    icon: "ri-mic-line",
    desc: "音乐竞演、户外真人秀、美食竞技，轻松下饭。",
  },
  {
    key: "动漫",
    label: "动漫",
    icon: "ri-robot-line",
    desc: "热门新番、治愈日常与热血机战，追番不停。",
  },
];

export const heroSlides = [
  {
    id: "hero-1",
    movieId: "mv-01",
    title: "星际迷航：黎明",
    subtitle: "年度最受期待的太空科幻巨制，一场关于抉择与希望的深空远征。",
    tag: "科幻首播",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20science%20fiction%20scene%20of%20a%20vast%20starfield%20with%20a%20colossal%20glowing%20ringed%20planet%20and%20a%20sleek%20spacecraft%20silhouette%2C%20deep%20navy%20and%20amber%20cinematic%20glow%2C%20dramatic%20volumetric%20light%2C%20atmospheric%20nebula%20haze%2C%20ultra%20detailed%2C%20moody%20epic%20composition&width=1600&height=900&seq=hero-slide-01&orientation=landscape",
  },
  {
    id: "hero-2",
    movieId: "tv-01",
    title: "长安风云录",
    subtitle: "年度口碑权谋大剧，寒门少年一步步走入权力中心。",
    tag: "口碑热剧",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20ancient%20eastern%20imperial%20palace%20at%20dusk%20with%20glowing%20lanterns%20and%20drifting%20golden%20leaves%2C%20rich%20crimson%20and%20deep%20gold%20palette%20with%20indigo%20shadows%2C%20dramatic%20atmospheric%20haze%2C%20epic%20moody%20lighting%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=hero-slide-02&orientation=landscape",
  },
  {
    id: "hero-3",
    movieId: "an-01",
    title: "龙之谷传说",
    subtitle: "被视作灾星的少年唤醒沉睡古龙，一段关于勇气与羁绊的旅程。",
    tag: "热血新番",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20fantasy%20anime%20scene%20of%20a%20colossal%20ancient%20dragon%20soaring%20over%20floating%20mountains%20with%20glowing%20runes%2C%20vivid%20teal%20and%20warm%20gold%20palette%2C%20epic%20dramatic%20volumetric%20light%2C%20atmospheric%20clouds%2C%20detailed%20anime%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-slide-03&orientation=landscape",
  },
  {
    id: "hero-4",
    movieId: "tv-03",
    title: "迷雾追凶",
    subtitle: "高分悬疑犯罪剧，浓雾小城每七年发生一起未解失踪案。",
    tag: "高分悬疑",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20misty%20harbor%20town%20at%20night%20with%20fog%20rolling%20over%20dim%20waterfront%20streets%20and%20a%20single%20warm%20lamp%2C%20cold%20steel%20blue%20palette%20with%20amber%20highlight%2C%20tense%20atmospheric%20haze%2C%20moody%20dramatic%20lighting%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=hero-slide-04&orientation=landscape",
  },
  {
    id: "hero-5",
    movieId: "mv-04",
    title: "深海奇缘",
    subtitle: "潜入从未被人类踏足的海沟，遇见比传说更温柔的深海世界。",
    tag: "视效大片",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20underwater%20deep%20ocean%20trench%20with%20bioluminescent%20coral%20and%20a%20giant%20whale%20silhouette%20drifting%20through%20god%20rays%2C%20deep%20teal%20aqua%20palette%20with%20warm%20accents%2C%20atmospheric%20particles%2C%20dramatic%20lighting%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=hero-slide-05&orientation=landscape",
  },
];

export const specials = [
  {
    id: "sp-01",
    title: "年度科幻精选",
    subtitle: "穿越星海与时间",
    reason: "从深空远征到时间裂缝，一次看完年度最值得的科幻佳作。",
    movieIds: ["mv-01", "mv-04", "mv-05", "an-02"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20abstract%20science%20fiction%20collage%20of%20deep%20space%20nebula%2C%20glowing%20time%20portal%20and%20a%20distant%20ringed%20planet%2C%20deep%20navy%20and%20warm%20amber%20glow%2C%20dramatic%20volumetric%20light%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20no%20text&width=800&height=500&seq=special-cover-01&orientation=landscape",
  },
  {
    id: "sp-02",
    title: "悬疑烧脑合集",
    subtitle: "真相总在最后一刻",
    reason: "反复反转、层层递进，献给热爱推理与烧脑的你。",
    movieIds: ["mv-03", "mv-05", "tv-03", "mv-02"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20abstract%20mystery%20collage%20of%20rain-soaked%20night%20street%20with%20glowing%20lamps%2C%20a%20magnifying%20glass%20and%20swirling%20fog%2C%20cold%20steel%20blue%20palette%20with%20warm%20amber%20accent%2C%20tense%20dramatic%20lighting%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20no%20text&width=800&height=500&seq=special-cover-02&orientation=landscape",
  },
  {
    id: "sp-03",
    title: "都市情感剧场",
    subtitle: "在钢筋森林里寻找温度",
    reason: "从职场甜宠到治愈慢生活，陪你度过每一个加班的夜晚。",
    movieIds: ["tv-02", "tv-04", "tv-05", "tv-06"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20abstract%20urban%20romance%20collage%20of%20a%20glowing%20city%20skyline%20at%20night%2C%20warm%20streetlights%20and%20soft%20bokeh%2C%20deep%20blue%20palette%20with%20warm%20coral%20highlights%2C%20dreamy%20atmospheric%20haze%2C%20ultra%20detailed%2C%20no%20text&width=800&height=500&seq=special-cover-03&orientation=landscape",
  },
  {
    id: "sp-04",
    title: "合家欢动画季",
    subtitle: "全年龄段的欢乐时光",
    reason: "热血、治愈、奇幻一网打尽，适合全家一起看的动画清单。",
    movieIds: ["an-01", "an-02", "an-03", "an-04"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20abstract%20animation%20collage%20of%20a%20soaring%20fantasy%20dragon%2C%20a%20towering%20mecha%20robot%20and%20blooming%20cherry%20blossoms%2C%20vivid%20teal%2C%20warm%20gold%20and%20gentle%20pink%20palette%2C%20epic%20atmospheric%20light%2C%20detailed%20illustration%2C%20no%20text&width=800&height=500&seq=special-cover-04&orientation=landscape",
  },
];

export const regionOptions = ["全部", "大陆", "美国", "日韩", "港台", "欧洲"];
export const yearOptions = ["全部", "2025", "2024", "2023", "2022", "2021"];
export const sortOptions = [
  { key: "latest", label: "最新" },
  { key: "hot", label: "热门" },
  { key: "rating", label: "评分" },
];